import { useQuery } from "@apollo/client/react";
import { useIntl } from "react-intl";
import { PersonsByIdsDocument } from "@/graphql/generated/operations";
import { PersonResultRow } from "@/components/common/PersonResultRow";
import { Button } from "@/components/design/Button";
import { userErrorMessage } from "@/lib/user-error";

export function AccessImpactPeople({ personIds }: { personIds: string[] }) {
  const intl = useIntl();
  const { data, loading, error, refetch } = useQuery(PersonsByIdsDocument, {
    variables: { input: { first: personIds.length, where: { id: { in: personIds } } } },
    skip: personIds.length === 0,
  });
  const people = new Map(data?.persons.nodes.map((person) => [person.id, person]));
  return <>
    {loading && <p role="status">{intl.formatMessage({ id: "admin.roles.membersLoading" })}</p>}
    {error && <div className="space-y-2">
      <p role="alert">{userErrorMessage(intl, error)}</p>
      <Button variant="secondary" size="compact" onClick={() => void refetch().catch(() => undefined)}>
        {intl.formatMessage({ id: "admin.roles.retry" })}</Button>
    </div>}
    {!loading && !error && <ul className="mt-2 divide-y divide-ink/10">{personIds.map((id) => {
      const person = people.get(id);
      const name = person?.formattedName || intl.formatMessage({ id: "admin.roles.unnamedPerson" });
      return <li key={id}><PersonResultRow embedded id={`roles-impact-person-${id}`}
        person={{ id, name, avatarContent: person?.avatar?.content, avatarMime: person?.avatar?.mimeType }}
        title={name} sub={!person ? intl.formatMessage({ id: "admin.roles.personUnavailable" }) : undefined} /></li>;
    })}</ul>}
    {personIds.length === 0 && <p>{intl.formatMessage({ id: "admin.roles.impactNone" })}</p>}
  </>;
}
